// extracted by mini-css-extract-plugin
export default {"recos":"o4-z","productCardOverride":"p4-z","rowHasBadge":"q4-z"};